import Localize from "../utils/initLocalization";
class ScrollToTopButton extends HTMLElement {
    _isVisible = false;
    _isArrowFilled = false;
    static TOP_VAL = 0;
    static SCROLL_Y_VAL = 500;
    upArrowClickHandler = null;
    arrowTimeoutId = null;
    constructor() {
        super();
        this.className = "scroll-to-top-div rounded-pill slide-from-right shadow-lg";
        this.innerHTML = this.content();
    }
    content() {
        return `
            <div class="btn-warning text-black bg-gradient d-flex flex-row align-items-center justify-content-center gap-2 p-2 fw-medium rounded-5">
                <i class="bi bi-arrow-up-circle fs-4 fw-medium"></i>
                <span>${Localize.translate("common:scrollToTop:text")}</span>
            </div>
        `;
    }
    handleUpArrowChange() {
        const upArrow = this.querySelector(".bi-arrow-up-circle") || document.querySelector(".bi-arrow-up-circle");
        if (!upArrow)
            return;
        if (this.upArrowClickHandler) {
            this.removeEventListener("click", this.upArrowClickHandler);
        }
        this.upArrowClickHandler = () => {
            if (!this._isArrowFilled) {
                upArrow.classList.remove("bi-arrow-up-circle");
                upArrow.classList.add("bi-arrow-up-circle-fill");
                this._isArrowFilled = true;
                if (this.arrowTimeoutId) {
                    clearTimeout(this.arrowTimeoutId);
                }
                this.arrowTimeoutId = setTimeout(() => {
                    upArrow.classList.remove("bi-arrow-up-circle-fill");
                    upArrow.classList.add("bi-arrow-up-circle");
                    this._isArrowFilled = false;
                    this.arrowTimeoutId = null;
                }, 500);
            }
        };
        this.addEventListener("click", this.upArrowClickHandler);
    }
    toggleVisibility = () => {
        this._isVisible = window.scrollY > ScrollToTopButton.SCROLL_Y_VAL;
        this.style.display = this._isVisible ? "block" : "none";
        if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight) {
            this.style.display = "none";
        }
        this.handleHidingOnFooter();
    };
    scrollToTop = () => {
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReducedMotion) {
            this.classList.remove("slide-from-right");
        }
        window.scrollTo({
            top: ScrollToTopButton.TOP_VAL,
            behavior: prefersReducedMotion ? "instant" : "smooth",
        });
    };
    handleHidingOnFooter() {
        if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight) {
            this.style.display = "none";
        }
    }
    connectedCallback() {
        this.addEventListener("click", this.scrollToTop);
        this.handleUpArrowChange();
        window.addEventListener("scroll", this.toggleVisibility, { passive: true });
        this.toggleVisibility();
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.toggleVisibility);
        this.removeEventListener("click", this.scrollToTop);
        if (this.upArrowClickHandler) {
            this.removeEventListener("click", this.upArrowClickHandler);
            this.upArrowClickHandler = null;
        }
        if (this.arrowTimeoutId) {
            clearTimeout(this.arrowTimeoutId);
            this.arrowTimeoutId = null;
        }
    }
}
customElements.define("scroll-to-top-button", ScrollToTopButton);
export default ScrollToTopButton;
